module.exports = __webpack_public_path__ + "img/type3_bg2.05b67c69.png";